export default __webpack_public_path__ + "static/article-how-to-maximise-savings-02d064d94b9ae6df2e2bdb7de2811b94.jpg";